import { render } from "./RecentSkillsSection.vue?vue&type=template&id=1b0703a9&scoped=true"
import script from "./RecentSkillsSection.vue?vue&type=script&lang=js"
export * from "./RecentSkillsSection.vue?vue&type=script&lang=js"

import "./RecentSkillsSection.vue?vue&type=style&index=0&id=1b0703a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b0703a9"]])

export default __exports__